import { render, staticRenderFns } from "./folders-list-links.vue?vue&type=template&id=7a44955f&scoped=true"
import script from "./folders-list-links.vue?vue&type=script&lang=js"
export * from "./folders-list-links.vue?vue&type=script&lang=js"
import style0 from "./folders-list-links.vue?vue&type=style&index=0&id=7a44955f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a44955f",
  null
  
)

export default component.exports